// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import { fromJS } from 'immutable'
import initialState from './initialState'

import {
  ADD_MODULATION_DETAILS,
  ASSIGN_ENTITY_DETAILS,
  REMOVE_MODULATION_FROM_STATE,
  RESET_TO_INITIAL_STATE,
  UPDATE_STORED_MODULATION_DETAILS,
} from './types'

const setModulationsIndexes = mods => mods.map((m, i) => m.set('index', i + 1))

// ~m.get('throughput')
// because we want to sort throughput by greatest to least
const sortModulationsByThroughput = mods => (
  setModulationsIndexes(mods.sortBy(m => ~m.get('throughput')))
)

// removes the modulation then re-maps the indexes of all persisting mods
const removeThisModulation = (s, i) => (
  setModulationsIndexes(s.getIn(['initialValues', 'radioModulations']).remove(i))
)

const databaseDetails = (state = initialState, action) => {
  switch (action.type) {
    case ADD_MODULATION_DETAILS :
      return (
        state
          .setIn(
            ['initialValues', 'radioModulations'],
            sortModulationsByThroughput(state.getIn(['initialValues', 'radioModulations']).push(fromJS(action.modulationDetails)))
          )
          .setIn(
            ['initialValues', 'containsModulationUpdate'],
            true
          )
      )

    case ASSIGN_ENTITY_DETAILS :
      return state.merge(fromJS(action.details))

    case REMOVE_MODULATION_FROM_STATE :
      return (
        state
          .setIn(['initialValues', 'radioModulations'], removeThisModulation(state, action.modIndex))
          .setIn(['initialValues', 'containsModulationUpdate'], true)
      )

    case RESET_TO_INITIAL_STATE :
      return state.merge(initialState)

    case UPDATE_STORED_MODULATION_DETAILS :
      return (
        state
          // first set the updated modulation data
          .setIn(
            ['initialValues', 'radioModulations'],
            // make sure that it's placed in the right order based on the assigned throughputs of all modulations
            sortModulationsByThroughput(
              state
                .getIn(['initialValues', 'radioModulations'])
                .set(`${action.modulationDetails.index - 1}`, fromJS(action.modulationDetails))
            )
          )
          // then set that we've updated the modulation data so that we properly track that on radio details.
          .setIn(
            ['initialValues', 'containsModulationUpdate'],
            true
          )
      )

    default :
      return state
  }
}

export default databaseDetails
